import { EnquiriesCategoryDto } from '@careapp-group/ng-sdk';
import { CaEntityState } from '../../../store/entity-state/entity-state';
import { CaEntityReducer } from '../../../store/entity-state/entity-reducer';
import { BaseFilterType } from '../../../store/entity-state/entity-actions-factory';
import { EnquiriesTenantCategories } from './enquiries-tenant-categories.actions';
import { mergeReducers } from '../../../store/entity-state/merge-reducers';
import { createReducer, on } from '@ngrx/store';

/**
 * Category uses a composite ID, which our entity state
 * doesn't support, so we will wrap it
 */
export class EnquiriesCategoryWrapper {
  tenantId: string;
  label: string;
  get id() {
    return `${this.tenantId}.${this.label}`;
  }

  constructor(entity: EnquiriesCategoryDto) {
    this.tenantId = entity.tenantId;
    this.label = entity.label;
  }
}

export interface EnquiriesTenantCategoryState extends CaEntityState<EnquiriesCategoryWrapper> {}

export class EnquiriesTenantCategoryReducer extends CaEntityReducer<
  EnquiriesCategoryWrapper,
  BaseFilterType
> {
  customReducer = createReducer(
    { ...this.initialState },
    on(EnquiriesTenantCategories.ResponseSuccessCreateAction, (state, action) => {
      const superState = this.entityReducer(state, action);
      return {
        ...superState,
        paginators: {
          ...superState.paginators,
          [action.payload.tenantId]: {
            ...superState.paginators[action.payload.tenantId],
            ids: [...superState.paginators[action.payload.tenantId].ids, action.payload.id],
          },
        },
      };
    }),
    on(EnquiriesTenantCategories.ResponseSuccessDeleteByIdAction, (state, action) => {
      const superState = this.entityReducer(state, action);

      const [tenantId, label] = action.id.split('.');

      return {
        ...superState,
        paginators: {
          ...superState.paginators,
          [tenantId]: {
            ...superState.paginators[tenantId],
            ids: superState.paginators[tenantId].ids.filter((v) => v !== action.id),
          },
        },
      };
    }),
  );

  public reducer(state, action) {
    return this.combinedReducer(state, action);
  }

  public combinedReducer = mergeReducers(this.entityReducer, this.customReducer);
}

export const state = new EnquiriesTenantCategoryReducer(EnquiriesTenantCategories);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
